import LessonDetail from '../../../../lessons/ui/componentes/LessonDetail'

interface LessonContentProps {
  lesson: any
  course: any
}

const LessonContent = ({ lesson, course }: LessonContentProps) => {
  return <LessonDetail lesson={lesson} course={course} />
}

export default LessonContent
